// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA1dRXcu2hhUMmu3Yhj1p6zWdf6MAF11x8",
  authDomain: "venvgpt.firebaseapp.com",
  projectId: "venvgpt",
  storageBucket: "venvgpt.appspot.com",
  messagingSenderId: "535897576848",
  appId: "1:535897576848:web:e24cc5e08931587e8a8f15",
  measurementId: "G-NHBSHV413S"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
